import { ControllerRenderProps } from "react-hook-form";
import { PlatformLanguage } from "@/generated-api/models/PlatformLanguage";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export const LanguageLabelMap: Record<PlatformLanguage, string> = {
  [PlatformLanguage.ENGLISH]: "English",
  [PlatformLanguage.RUSSIAN]: "Russian",
};

export default function PlatformLanguageSelector({
  formField,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formField: ControllerRenderProps<any>;
}) {
  return (
    <Select onValueChange={formField.onChange} value={formField.value}>
      <SelectTrigger className="focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0">
        <SelectValue placeholder="Select language" />
      </SelectTrigger>
      <SelectContent className="dark">
        <SelectGroup>
          {Object.values(PlatformLanguage).map((value) => (
            <SelectItem className="py-3" key={value} value={value}>
              {LanguageLabelMap[value]}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
